import { RespuestaLecturaError } from '../../Mensajes';
import { llamadaAPI_DELETE, llamadaAPI_GET, llamadaAPI_GETBinario, llamadaAPI_POST, llamadaAPI_PUT } from '../../SQL';
import { FormateoFechaPara_yyyyMMdd_HHmmss, TratamientoDeParametroParaURI } from '../../Varios';
import { function_VEN_Reservas_MercadoPago_CheckDePago } from './VEN_Reservas_MercadoPago';

export const function_VEN_Reservas_Cabecera_Listar = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_VEN_Reservas_Cabecera_Listar"

    try {
        const resulData = await llamadaAPI_GET("VEN_Reservas_Cabecera/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            "NA*DA");
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Reservas_ResumenDeIndividuales = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_VEN_Reservas_ResumenDeIndividuales"

    try {
        const resulData = await llamadaAPI_GET("VEN_Reservas_Cabecera_ResumenParticipantes/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            "NA*DA");
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Reservas_ResumenDeIndividualesSinHoras = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_VEN_Reservas_ResumenDeIndividualesSinHoras"

    try {
        const resulData = await llamadaAPI_GET("VEN_Reservas_Cabecera/ResumenParticipantesSinHoras/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            "NA*DA");
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Reservas_ResumenDeEventos = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_VEN_Reservas_ResumenDeEventos"

    try {
        const resulData = await llamadaAPI_GET("VEN_Reservas_Cabecera/ResumenEventos/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            "NA*DA");
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Reservas_Cabecera_Leer = async (IdReserva) => {
    const NombreFuncion = "function_VEN_Reservas_Cabecera_Leer"

    try {
        const resulData = await llamadaAPI_GET("VEN_Reservas_Cabecera/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdReserva);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Reservas_Cabecera_LeerNombresAgasajados = async (IdReserva) => {
    const NombreFuncion = "function_VEN_Reservas_Cabecera_LeerNombresAgasajados"

    try {
        const resulData = await llamadaAPI_GET("VEN_Reservas_Cabecera/LeerNombresAgasajados/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdReserva);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Reservas_Cabecera_ResumenParticipantes = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_VEN_Reservas_Cabecera_ResumenParticipantes"

    try {
        const resulData = await llamadaAPI_GET("VEN_Reservas_Cabecera_ResumenParticipantes/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            "NA*DA");
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Reservas_Cabecera_ResumenParticipantesSinHoras = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_VEN_Reservas_Cabecera_ResumenParticipantesSinHoras"

    try {
        const resulData = await llamadaAPI_GET("VEN_Reservas_Cabecera/ResumenParticipantesSinHoras/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            "NA*DA");
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Reservas_Cabecera_ResumenVentas = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_VEN_Reservas_Cabecera_ResumenVentas"

    try {
        const resulData = await llamadaAPI_GET("VEN_Reservas_Cabecera_ResumenVentas/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            "NA*DA");
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Reservas_Cabecera_ResumenEventos = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_VEN_Reservas_Cabecera_ResumenEventos"

    try {
        const resulData = await llamadaAPI_GET("VEN_Reservas_Cabecera/ResumenEventos/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            "NA*DA");
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Reservas_Cabecera_Resumen = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_VEN_Reservas_Cabecera_Resumen"

    try {
        const resulData = await llamadaAPI_GET("VEN_Reservas_Cabecera/Resumen/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Reservas_Cabecera_ResumenLeible = async (FechaDesde, FechaHasta) => {
    const NombreFuncion = "function_VEN_Reservas_Cabecera_ResumenLeible"

    try {
        const resulData = await llamadaAPI_GET("VEN_Reservas_Cabecera/ResumenLeible/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Reservas_Cabecera_ListarPorCliente = async (FechaDesde, FechaHasta, IdCliente) => {
    const NombreFuncion = "function_VEN_Reservas_Cabecera_ListarPorCliente"

    try {
        const resulData = await llamadaAPI_GET("VEN_Reservas_Cabecera/PorCliente/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            FechaDesde + "/" +
            FechaHasta + "/" +
            IdCliente);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export async function function_VEN_Reservas_Cabecera_Mantenimiento() {
    const NombreFuncion = "function_VEN_Reservas_Cabecera_Mantenimiento"

    try {
        const resultMP = await function_VEN_Reservas_MercadoPago_CheckDePago(localStorage.getItem("CodigoCompania"))

        await llamadaAPI_POST("VEN_Reservas_Cabecera/Mantenimiento/" + localStorage.getItem("CodigoCompania"), resultMP)

        return true
    } catch (error) {
        const respuesta = await RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
}

export const function_VEN_Reservas_Cabecera_Insertar = async (Reserva) => {
    const NombreFuncion = "function_VEN_Reservas_Cabecera_Insertar";

    try {
        const reservaResult = await llamadaAPI_POST("VEN_Reservas_Cabecera/Completo",
            Reserva);

        return reservaResult;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_VEN_Reservas_Generar_JSON = async (idCliente, importeTotal, turno, fecha, esEvento,
    ColeccionDataDetalles, ColeccionDataIntegrantes) => {
    const NombreFuncion = "function_VEN_Reservas_Generar_JSON";

    try {
        const JSON = {
            IdReserva: 0,
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
            CodigoPlanta: localStorage.getItem("CodigoPlanta"),
            FechaCreacion: await FormateoFechaPara_yyyyMMdd_HHmmss(new Date()),
            IdClienteGenerador: idCliente,
            ImporteTotal: importeTotal,
            Terminal: localStorage.getItem("Terminal"),
            Turno: turno,
            FechaReservaInicio: await FormateoFechaPara_yyyyMMdd_HHmmss(fecha),
            EsEvento: esEvento,
            Detalles: ColeccionDataDetalles,
            Integrantes: ColeccionDataIntegrantes
        }
        return JSON
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_VEN_ReservasAnexo_Generar_JSON = async (idCliente, importeTotal, turno, fecha, esEvento,
    ColeccionDataDetalles, ColeccionDataIntegrantes, IdReservaOrigen) => {
    const NombreFuncion = "function_VEN_Reservas_Generar_JSON";

    try {
        const JSON = {
            IdReserva: 0,
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
            CodigoPlanta: localStorage.getItem("CodigoPlanta"),
            FechaCreacion: await FormateoFechaPara_yyyyMMdd_HHmmss(new Date()),
            IdClienteGenerador: idCliente,
            ImporteTotal: importeTotal,
            Terminal: localStorage.getItem("Terminal"),
            Turno: turno,
            FechaReservaInicio: await FormateoFechaPara_yyyyMMdd_HHmmss(fecha),
            EsEvento: esEvento,
            Detalles: ColeccionDataDetalles,
            Integrantes: ColeccionDataIntegrantes,
            IdReservaOrigen: IdReservaOrigen
        }
        return JSON
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_VEN_Reservas_Cabecera_ReporteReserva = async (IdReserva, formato) => {
    const NombreFuncion = "function_VEN_Reservas_Cabecera_ReporteReserva";

    try {
        const resulData = await llamadaAPI_GETBinario("VEN_Reservas_Cabecera/GenerarDocumento/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdReserva);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Reservas_Cabecera_ReporteReserva_EnvioMail = async (IdReserva, toEmail) => {
    const NombreFuncion = "function_VEN_Reservas_Cabecera_ReporteReserva_EnvioMail";

    try {
        const resulData = await llamadaAPI_GET("VEN_Reservas_Cabecera/EnvioMail/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdReserva + "/" +
            await TratamientoDeParametroParaURI(toEmail));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Reservas_Cabecera_MarcaDeEvento = async (IdReserva) => {
    const NombreFuncion = "function_VEN_Reservas_Cabecera_MarcaDeEvento";

    try {
        const resulData = await llamadaAPI_PUT("VEN_Reservas_Cabecera/MarcaDeEvento/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdReserva);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Reservas_Cabecera_QuitarMarcaDeEvento = async (IdReserva) => {
    const NombreFuncion = "function_VEN_Reservas_Cabecera_QuitarMarcaDeEvento";

    try {
        const resulData = await llamadaAPI_PUT("VEN_Reservas_Cabecera/QuitarMarcaDeEvento/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdReserva);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_VEN_Reservas_Cabecera_Eliminar = async (IdReserva) => {
    const NombreFuncion = "function_VEN_Reservas_Cabecera_Eliminar"

    try {
        const resulData = await llamadaAPI_DELETE("VEN_Reservas_Cabecera/Eliminar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            IdReserva);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};